import React from "react";
import { Link } from "react-router-dom";
import Footer from "../Footer";
function Cerita2() {
  const isiCerita = [
    {
      id: 1,
      title: "Ok, Mulai dari SMK biar tidak terlalu panjang",
      desc: "Ketertarikan dunia IT muncul ketika daftar SMK, masuk jurusan TKJ pada saat itu, namun hanya sehari,<b> Yaa satu hari</b>, alasanya hanya karena cowoknya sedikit, alasan yang aneh sih, lalu pindah ke otomotif dan lulus dengan keterampilan otomotif, sedikit tau tapi tidak banyak, kalo disuruh buka bengkel belum berani sih🧐 <br /> <p class='mb-4 text-lg font-normal text-slate-400 mt-8'> Note : Pengalaman komputer disini masih 0 banget ya, hanya tau ms.word dan ngulik animasi power point</p>",
    },
    {
      id: 2,
      title: "Lanjut Masuk Kuliah",
      desc: " Kalau disini beda cerita, berharap masuk jurusan informatika, namun hanya ada teknik komputer, akhirnya diputuskan masuk jurusan akuntansi, lagi lagi tidak nyambung🤭,<b> Jadi Begini</b>, pada saat itu program untuk teknik komputer hanya ada untuk D3, dan karena anak beasiswa yang mana hanya tersedia untuk program S1 Akuntansi, jadi tidak ada pilihan lain, sempat berfikir untuk mundur, karena jurusan ini jauh dari keinginan pribadi untuk mendalami IT",
    },
    {
      id: 3,
      title: "Bagian ini yang seru",
      desc: " Kenapa memutuskan untuk tetap lanjut padahal salah jurusan?, sebagai catatan di kampus dulu tidak hanya kuliah, namun juga bekerja, kebetulan bagian saat itu <b>IT Support,</b> ada bau bau IT nya lah ya.",
    },
    {
      id: 4,
      title: "Sudah Ketebak ?",
      desc: "Betul, itu alasan terbesar sih untuk lanjut kuliah, dimana harus bisa memaksimalkan disana (dikerjaan), tentunya belajar banyak disana, sampai suatu ketika entah semester 3/4 mulai kenal dengan programming (web), bermula ketika matakuliah web 1 dikelas lain dan diminta ikut kelas, keren ya anak akuntansi belajar web🤫,",
    },
    {
      id: 5,
      title: "Pertama Kali liat Baris Kode ?",
      desc: "Yang pasti pusing ya, bingung ini tulisan apa dari planet mana, kata teman, FYI di mata kuliah ini belajar HTML,CSS untuk basicnya, lagi lagi sampai sini merasa salah jurusan, di pertemuan ke-2 tibalah saat ketika dosen menjalankan kode programnya, <b>sebut saja Open in Browser</b>😄, keren juga ya!!",
    },
    {
      id: 6,
      title: "Programming Ternyata Keren",
      desc: "Pertanyaan yang pertama kali muncul dalam benak, 'Kok Bisa?', saat itu juga ngomong keatasan,suka dengan matakuliah ini,ingin belajar dan mau mendalaminya, kalo orang bilang jatuh cinta pada pandangan yang ke-2 kali yaa, sering di kasih challenge, salah satunya bikin <b>UI sistem absensi</b> dikampus versi web (sebelumnya VB), dan ini challenge yang gokil sih👇",
    },
    {
      id: 7,
      title: "Mengajar Web 2 (PHP) Hampir 1 Semester",
      desc: "Pengalaman yang luar biasa, menjadi dosen pengganti selama itu, dengan mata kuliah yang tidak gampang tentunya, tantanganya dimana harus bisa keluar dari pribadi sebelumnya yang introvert dan berkomunikasi dengan banyak orang, membuat mereka paham atas apa yang disampaikan, awal awal gemetaran, tidak tau mau ngomong apa, lama lama terbiasa dan bisa menikmatinya, 🤔 seperti iklan",
    },
    {
      id: 8,
      title: "Apa Materinya?",
      desc: "Materi PHP dasar seperti sejarah PHP, syntak basic, CRUD, sistem login, Auth.<br /><p class='mb-4 mt-8 text-lg font-normal text-slate-400'>Note : Disini skill koding basic, namun kebanyakan teoritis untuk kebutuhan mengajar tadi</p>",
    },
    {
      id: 9,
      title: "Pindah Bagian Staff Administrasi",
      desc: "Karena bekerja di suatu instansi otomatis harus ikut aturan perusahaan, walaupun tidak nyambung dengan yang sudah dipelajari, paling tidak nyambung dengan jurusan kuliah, itung itung mempertanggungjawabkan keputusan yang sudah diambil😁, 2 Tahun yang lumayan di bagian ini, Next...",
    },
    {
      id: 10,
      title: "The Latest Development of My Code🚀",
      desc: "  Lulus kuliah resign untuk <b>memperdalam skill koding,</b> belajar lebih banyak teknologi, dan membuat sedikit project, engga bagus tapi bikin sendiri😉",
    },
  ];

  return (
    <div
      className="text-xl text-slate-700 dark:text-gray-200"
      data-aos="zoom-up"
    >
      <h1 className="text-2xl md:text-3xl font font-semibold mb-2">
        Sedikit Cerita
      </h1>
      <p className="text-lg md:text-xl font-normal">
        Judulnya mungkin{" "}
        <span className="text-pink-500 font-semibold">
          Road map menuju Koding
        </span>
        , diperuntukan kepada orang/mahasiswa yang salah jurusan. Sedikit agak
        serem sih🙄
      </p>
      <ol class="relative border-l mt-10 border-gray-200">
        {isiCerita.map((res) => (
          <li class="mb-10 ml-6">
            <span class="flex absolute -left-3 justify-center items-center w-6 h-6 bg-gray-50 rounded-full ring-4 ring-gray-200">
              <svg
                class="w-3 h-3 dark:text-blue-400"
                fill="currentColor"
                viewBox="0 0 20 20"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z"
                  clip-rule="evenodd"
                ></path>
              </svg>
            </span>
            <button>
              <h3 class="flex text-left underline underline-offset-auto decoration-4 decoration-pink-500 items-center mb-2 text-lg font-semibold text-slate-700 dark:text-gray-200">
                {res.title}
              </h3>
            </button>
            <p
              class="mb-4 text-lg md:text-xl font-normal text-slate-700 dark:text-gray-200"
              dangerouslySetInnerHTML={{ __html: res.desc }}
            />
          </li>
        ))}
        <Link to="/karya">
          <p className="ml-6 -mt-6 underline underline-offset-4 decoration-4 decoration-sky-500">
            Ini projectnya
          </p>
        </Link>
      </ol>
      <Footer />
    </div>
  );
}

export default Cerita2;
